import { useState } from "react";
import CustomDialogSmall from "../../../components/Dialog/DiaCompSmall"
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Grid from '@mui/material/Grid';
import RescheduleForm from "./RescheduleForm";

export default function DiaRescheduleLab({infotitle, infotext}) {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
  
        <Tooltip title="Reschedule Lab Visit" placement="right">
            <IconButton onClick={handleOpen} aria-label="Reschedule" sx={{ '&:hover': {transform: 'scale(1.2)'}, }} >
                <CalendarMonthIcon size="large" sx={{color: 'warning.main', '&:hover': { transform: 'scale(1.3)'}, }}/>
            </IconButton>   
        </Tooltip>
   
    <CustomDialogSmall open={open} onClose={handleClose}

          title="Reschedule your lab visit"
         
          content = {
          
           <Grid container>

              <Grid size={12} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>  
                <RescheduleForm />
              </Grid>
            
            </Grid>
            }

        />
        
</>
)}